import { render, staticRenderFns } from "./CourseBuilderPresentationForm.vue?vue&type=template&id=185d2adc&scoped=true&"
import script from "./CourseBuilderPresentationForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderPresentationForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderPresentationForm.vue?vue&type=style&index=0&id=185d2adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d2adc",
  null
  
)

export default component.exports